import React, { useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import { CardPersonalTrainer, AppHeader } from '../../../components/common';
import { AppText } from '../../../components/form';
import { getTrainers } from '../../../redux/actions/trainerActions';
import { UserActions } from '../../../redux/reducers/userReducer';
import styles from './styles';

export default function SelectPersonal({ navigation }) {
  const dispatch = useDispatch();
  const { trainerList, userSignUp } = useSelector((state) => state.user);
  useEffect(() => {
    dispatch(getTrainers(userSignUp));
  }, []);
  const handleSelectTrainer = (id_profissional) => {
    dispatch({
      type: UserActions.UPDATE_SIGNUP,
      userSignUp: {
        ...userSignUp, id_profissional,
      },
    });
    navigation.navigate('Profile Trainer', { screen: 'Confirmação Personal Trainer' });
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Personal Trainer" />
      <View style={styles.container}>
        <AppText style={styles.title}>Selecione seu Personal Trainer</AppText>
        <ScrollView>
          { !!trainerList?.length && trainerList.map(({
            id_profissional, nome, cref, foto, mini_cv,
          }, index) => (
            <CardPersonalTrainer
              key={index}
              personalName={nome}
              cref={cref}
              exp={mini_cv}
              profilePic={foto}
              onPress={() => handleSelectTrainer(id_profissional)}
            />
          ))}
        </ScrollView>
      </View>
    </>
  );
}
